export default __webpack_public_path__ + "static/media/1799.546cd55b.png";